import { render } from "./CheckIcon.vue?vue&type=template&id=4e5c63ed"
import script from "./CheckIcon.vue?vue&type=script&lang=js"
export * from "./CheckIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__